module.exports = __webpack_public_path__ + "5a2874bd98c04d12b895dae89fdb327d.pdf";